<template>
  <Modal class="long-modal top-modal"  width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">
      查看
    </div>
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="loading"></table-list>
    </div>
    <img-show :n="imgN" :src="imgSrc"></img-show>
    <div slot="footer">
      <div>  
        <Button  type="primary" size="large" @click="close">确定</Button>
      </div>
    </div>
  </Modal>
</template>
 
<script type="text/ecmascript-6">
 import {formatDateTime} from "@/utils/format.js"
 import TableList from "components/TableList/index";
 import { getReceiveFollow } from 'api/accountsReceivable'
 import ImgShow from 'components/ImgListShow/index'
 
export default {
  components:{
    TableList,
    ImgShow
  },
  props:{
    n:{
      type:Number,
      default:0
    },
    billId:{
      type:Number,
      default:null
    },
    contractCode:{
      type:String,
      default:''
    }
  },
  watch:{
    n() { 
      this.show = true
      this.loading = true
      let params = {
        contractCode:this.contractCode,
        billId:this.billId
      }
      getReceiveFollow(params).then( res => {
        this.tableData = res.data
      }).finally( () => {
        this.loading = false
      })
    }
  },
 data () {
  return {
    show:false,
    loading:false,
    tableData:[],
    imgSrc: [],
    imgN: 0,
    columns:[
      {
        title: "跟进时间",
        key: "urgeTime",
        align: "center",
        render: (h,params) => {
          return h('div',formatDateTime(params.row.urgeTime).slice(0, 16))
        }
      },
      {
        title: "跟进人",
        key: "followName",
        align: "center"

      },
      {
      title: "跟进记录",
      key: "urgeDesc",
      align: "center"
      },
      {
        title: "图片",
        key: "urlList",
        align: "center",
        render: (h, params) => {
          return (params.row['urlList'] && params.row['urlList'].length > 0) ? h('a', {
            on: {
              click: () => {
                let imgList = []
                params.row['urlList'].forEach((ele, index) => {
                  imgList.push(ele.url)
                })
                this.imgSrc = imgList
                this.imgN++
              }
            }
          }, '查看') : h('span', {}, '无')
        }
      }
    ]
 };
 },
 methods:{
   close() {
     this.show = false
   }
 }
}
</script>




